<script lang="ts">
	import Daze from '$lib/assets/images/icons/daze-circle.svg?component';
	import __ from '$lib/stores/TranslationStore';

	export let name: string;
</script>

<section class="mx-auto flex flex-col items-center justify-center gap-5 md:flex-row">
	<div>
		<Daze />
	</div>
	<div class="flex flex-col gap-5">
		<h2 class="text-4xl">
			<strong>{name}</strong>, {$__('ainda não encontrámos o seguro ideal para si')}
		</h2>
		<h3 class="text-lg">
			{$__(
				'De momento, algo nos impediu de identificar a melhor solução para o seu caso. Estamos a analisar a situação com mais detalhe e entraremos em contacto consigo brevemente.'
			)}
		</h3>
		<p class="text-sm">
			<strong>{$__('Dica')}</strong>: {$__(
				"Verifique o campo 'valor do crédito contratado', pois este poderá estar inferior ao habitual"
			)}
		</p>
	</div>
</section>
